<template>
    <div class="servico">
        <!-- Página: Manutenção de Máquinas e Motores -->
        <section id="manutencao-maquinas" class="servico-section">
            <h2>Telecomunicações</h2>
            <img src="@/assets/images/telecomunicacao.jpg" alt="Motor Industrial" class="servico-img" />
      <h2>Soluções para conectividade e segurança</h2>
      <ul class="servico-lista">
        <li><button @click="abrirModal('modal1')">Instalação de sistemas de comunicação interna (intercomunicadores, CCTV)</button></li>
        <li><button @click="abrirModal('modal2')">Montagem de redes estruturadas e cabeamento</button></li>
        <li><button @click="abrirModal('modal3')">Manutenção de antenas, roteadores e repetidores de sinal</button></li>
      </ul>
    </section>

    <!-- Modal 1 -->
    <div v-if="modalAberto === 'modal1'" class="modal-overlay">
      <div class="modal-content">
        <h3>Instalação de sistemas de comunicação interna (intercomunicadores, CCTV)</h3>
        <p><strong>Descrição:</strong>  Montagem de sistemas de vigilância e intercomunicação</p>
        <p><strong>Benefício:</strong>  Garante segurança e comunicação eficiente.</p>
        <p><strong>Exemplo:</strong> CCTV em condomínio no Bairro da Luz</p>
        <p><strong>Prazo:</strong> Simples (1-2 dias); Complexo (3-7 dias)</p>
        <p><strong>Pagamento:</strong>  Simples (completo); Complexo (diagnóstico + parcelado)</p>
        <p><strong>Normas:</strong> EN 50132, TIA/EIA-568.</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>

    <!-- Modal 2 -->
    <div v-if="modalAberto === 'modal2'" class="modal-overlay">
      <div class="modal-content">
        <h3>Montagem de redes estruturadas e cabeamento</h3>
        <p><strong>Descrição:</strong> Configuração de redes de dados (ex.: Cat6, fibra óptica)</p>
        <p><strong>Benefício:</strong> Suporta conectividade confiável para empresas</p>
        <p><strong>Exemplo:</strong>   Rede LAN em escritório no Lobito</p>
        <p><strong>Prazo:</strong>  Complexo (3-10 dias).</p>
        <p><strong>Pagamento:</strong> Diagnóstico + parcelado</p>
        <p><strong>Normas:</strong> TIA/EIA-568, ISO/IEC 11801</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>

    <!-- Modal 3 -->
    <div v-if="modalAberto === 'modal3'" class="modal-overlay">
      <div class="modal-content">
        <h3>Manutenção de antenas, roteadores e repetidores de sinal</h3>
        <p><strong>Descrição:</strong> Inspeção e reparo de equipamentos de comunicação sem fio</p>
        <p><strong>Benefício:</strong>  Garante qualidade de sinal e conectividade</p>
        <p><strong>Exemplo:</strong> Ajuste de antena Wi-Fi em empresa local</p>
        <p><strong>Prazo:</strong> Simples (2-4 horas); Complexo (1-2 dias).</p>
        <p><strong>Pagamento:</strong> Simples (completo); Complexo (diagnóstico + parcelado).</p>
        <p><strong>Normas:</strong>  ETSI, FCC.</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalAberto: null,
    };
  },
  methods: {
    abrirModal(modalId) {
      this.modalAberto = modalId;
    },
    fecharModal() {
      this.modalAberto = null;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>


<style scoped>
.servico {
  padding: 40px;
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
}

.servico-section {
  margin-bottom: 60px;
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.servico-section h1,
h2 {
  text-align: center;
  color: #005580;
  margin-bottom: 20px;
}

.servico-section h1 {
  font-size: 28px;
  border-bottom: 2px solid #005580;
  padding-bottom: 10px;
}

.servico-section h2 {
  font-size: 20px;
  font-weight: normal;
}

.servico-img {
  display: block;
  margin: 0 auto 20px auto;
  width: 50%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}

.servico-lista {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.servico-lista li button {
  background-color: #005580;
  color: white;
  border: none;
  padding: 12px 18px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  text-align: center;
}

.servico-lista li button:hover {
  background-color: #0077a6;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
}

.modal-content h3 {
  margin-top: 0;
  color: #005580;
  margin-bottom: 20px;
  text-align: center;
}

.modal-content p {
  margin: 10px 0;
  line-height: 1.5;
  color: #333;
}

.fechar-btn {
  display: block;
  margin: 20px auto 0 auto;
  background-color: #cc0000;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.fechar-btn:hover {
  background-color: #e60000;
}

@keyframes fadeIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>